<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title class="card-header fixed-card-title2">
			{{ $t('edit-organization-mapping-pcc') }}
			<v-spacer></v-spacer>
			<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-2">
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedOrganizationToEdit.orgUuid"
						:label="`${$t('organization')} GUID`"
						required>
					</v-text-field>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedOrganizationToEdit.pccOrganizationName"
						:label="`${$t('organization')} ${$t('name')} `"
						required>
					</v-text-field>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-select
						class="py-1"
						hide-details
						dense
						v-model="selectedOrganizationToEdit.medicalInstitutionId"
						:items="allMedicalInstitutions"
						item-value="id"
						item-text="institutionName"
						:label="$t('medical-institutions')"
						outlined>
					</v-select>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedOrganizationToEdit.pccCompanyCode"
						:label="`${$t('organization')} ${$t('code')} `"
						required>
					</v-text-field>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-textarea
						rows="3"
						v-model="selectedOrganizationToEdit.description"
						outlined
						dense
						:label="$t('description')"></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions class="fixed-card-actions">
			<v-row dense class="mx-0 px-0 mr-2">
				<v-col cols="6">
					<v-btn elevation="0" @click="closeDrawer" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn :disabled="isSaveButtonDisabled()" @click="editOrganizationMapping" class="save-button-style">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	name: 'OrganizationMappingEdit',
	data: () => ({
		selectedOrganizationToEdit: {
			id: -1,
			orgUuid: '',
			pccOrganizationName: '',
			medicalInstitutionId: null,
			pccCompanyCode: '',
			description: '',
		},
	}),
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			hospitals: (state) => state.hospitals.hospitals,
			selectedOrganization: (state) => state.mapping.selectedOrganization,
			updateDrawer: (state) => state.updateDrawer,
		}),
		...mapGetters({
			getTimeZone: 'verifiers/getTimeZone',
		}),
	},
	mounted () {
		this.selectedOrganizationToEdit.id = this.selectedOrganization.pccCompanyMapping.id;
		this.selectedOrganizationToEdit.orgUuid = this.selectedOrganization.orgUuid;
		this.selectedOrganizationToEdit.pccOrganizationName = this.selectedOrganization.pccOrganizationName;
		this.selectedOrganizationToEdit.medicalInstitutionId = this.selectedOrganization.pccCompanyMapping.mappedCompanyId;
		this.selectedOrganizationToEdit.pccCompanyCode = this.selectedOrganization.pccCompanyMapping.pccCompanyCode;
		this.selectedOrganizationToEdit.description = this.selectedOrganization.pccCompanyMapping.description;
	},
	methods: {
		...mapActions({
			editPccMapForCompany: 'pcc/editPccMapForCompany',
		}),
		isSaveButtonDisabled () {
			return (
				!this.selectedOrganizationToEdit.orgUuid.length ||
				!this.selectedOrganizationToEdit.pccOrganizationName.length ||
				!this.selectedOrganizationToEdit.medicalInstitutionId ||
				!this.selectedOrganizationToEdit.pccCompanyCode
			);
		},
		resetComponent () {
			this.selectedOrganizationToEdit = {
				id: -1,
				orgUuid: '',
				pccOrganizationName: '',
				medicalInstitutionId: null,
				pccCompanyCode: '',
				description: '',
			};
		},
		async editOrganizationMapping () {
			await this.editPccMapForCompany(this.selectedOrganizationToEdit);
			this.closeDrawer();
		},
		closeDrawer () {
			this.resetComponent();
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
	},
	watch: {
		updateDrawer (val) {
			if (val) {
				this.selectedOrganizationToEdit = this.selectedOrganization;
			}
		},
	},
};
</script>
<style scoped>
.map-container {
	margin-top: 20px;
	/* Adjust this margin as needed */
}
</style>
